<template>
  <div :id="this.$route.name">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">فیلتر اطلاعات</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row" id="taskmanagerrow">
          <div v-if="!IsComponent" class="col-md-2 col-12">
            <small id="LblUserId">کاربر</small>
            <SearchableCombo
              :edit="false"
              :grp="0"
              :code="null"
              @ResultCombo="GetResulUserId"
              :rownumintable="3"
              :defaultvalue="IsComponent ? null : DataAxios.TblUserIdTask"
              :action="'TblCrmCombo/GetUserDatailsTask/' + $session.get('UserInfo').tblUserId"
              :method="'POST'"
              :idinput="'UserIdTask'"
              :keyItem="'UserIdTask'"
              :disabled="false"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-3 col-12">
            <small id="LblTblCostomer">مربوط به مشتری</small>
            <SearchableCombo
              :edit="false"
              :grp="0"
              :code="null"
              @ResultCombo="GetResulTblCostomer"
              :rownumintable="3"
              :defaultvalue="IsComponent ? CustomerIdprop : DataAxios.TblCustomerId"
              :action="'TblCrmCombo/GetCostomer'"
              :method="'POST'"
              :idinput="'TblCostomer'"
              :keyItem="'TblCostomer'"
              :disabled="IsComponent"
              :LazyLoad="!IsComponent"
            >
            </SearchableCombo>
          </div>
          <div class="col-lg-2 col-12">
            <small id="LbltarixAz"> از تاریخ</small>
            <date-picker color="dimgray" v-model="tarix[0]" clearable :editable="true" placeholder=" تاریخ "></date-picker>
          </div>
          <div class="col-lg-2 col-12">
            <small id="LbltarixAz"> تاریخ تا</small>
            <date-picker color="dimgray" v-model="tarix[1]" clearable :editable="true" placeholder=" تاریخ "></date-picker>
          </div>
          <div class="col-lg-1 col-12">
            <small id="LblDone"> وضعیت انجام</small>
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input InputText" id="Done" v-model="DataAxios.Done" />
              <label class="custom-control-label" for="Done"> </label>
            </div>
          </div>
          <div class="col-lg-2 col-12" dir="ltr">
            <small id="LblIsReply"> نیاز به پاسخ </small>
            <!-- <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input InputText" id="IsReply" v-model="DataAxios.IsReply" />
              <label class="custom-control-label" for="IsReply"> </label>
            </div> -->
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group id="btn-radios-2" v-model="selected" :options="options" :aria-describedby="ariaDescribedby" button-variant="outline-info" size="sm" name="radio-btn-outline" buttons @change="ChangRadio(selected)">
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 col-md-10 col-12"></div>
          <div class="col-lg-2 col-md-2 col-12">
            <button class="btn btn-success mt-4 w-100 float-left" dir="ltr" @click.prevent="Search()"><span class="mr-2"> جستجو </span><span class="fas fa-search"></span></button>
          </div>
        </div>
      </template>
    </card>
    <card :loading="loadingRender" tools toolsColumns>
      <template v-slot:header>
        <h4 class="d-inline">مـدیریت کـارهـا</h4>
        <hr />
      </template>
      <template v-slot:content>
        <BnpGrid v-if="$store.state.renderComponentTicket" :Sortable="true" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :Selectable="false" :action="true">
          <template slot="action-slot" slot-scope="props">
            <!-- <button v-if="!props.props.Done" class="btn btn-lg text-success" @click="DoneTask(props.props); " title="انجام شد"><i class="fad fa-user-check"></i></button> -->
            <a v-if="$session.get('UserInfo').tblUserGrpId == props.props.TblUserGrpIdInsert && props.props.Done == false && props.props.IsView == false" href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.props)"
              ><h6><span class="fas fa-marker text-secondary hover-warning"></span></h6
            ></a>
            <a v-if="props.props.TblUserIdTask == $session.get('UserInfo').tblUserId" href="javascript:;" class="mr-2 badge" @click="OnView(props.props)" title="مشاهده"
              ><h6><span v-if="props.props.IsView == false" class="fas fa-eye font-weight-bold hover-danger"></span><span v-else class="fas fa-check-double font-weight-bold hover-info"></span></h6
            ></a>
            <a v-if="!CustomerIdprop & props.props.TblCustomerId != null"  href="javascript:;" class="mr-2 badge" @click="OnPersonel(props.props)" title="پرسنل"><h6><span class="fad fa-address-book"></span></h6></a>
            <a v-if="!CustomerIdprop & props.props.TblCustomerId != null" href="javascript:;" class="mr-2 badge" @click="OnPhone(props.props)" title="تماس ها"><h6><span  class="fad fa-phone"></span></h6></a>
          </template>
          <template slot="CustomerName" slot-scope="props">
            <a href="javascript:;" @click="$FindeCustomerById('DetailCustomer',props.props.TblCustomerId,1,$event)" 
                                     @click.middle="$FindeCustomerById('DetailCustomer',props.props.TblCustomerId,1,$event)">{{ props.props.CustomerName }}</a>
          </template>
        </BnpGrid>
      </template>
    </card>
      <modal v-if="$store.state.Modal && IsComponent==false"      :InheritanceTheme="true"      :IsFooter="false"      :Size="'Lg'">
      <template  v-slot:body>
      <div v-if="modal1 && IsComponent==false" class="row m-1">
          <div v-for="(person, index) in Customer.Personel" :key="index" class="col-md-3 col-12 p-2">
            <CardBox>
              <template v-slot:cardbox-icon1>
                <i v-if="person.IsActive == true" class="fad fa-archive mt-2" title="کاربر بایگانی شده"></i>
                <i v-else-if="person.tblUserIdLogin != 0 && person.IsActive == false" class="fad fa-user-check mt-2" title=" کاربر سامانه CRM "></i>
                <i v-else-if="person.IsPerRabetAsli" class="fad fa-user-crown mt-2" title=" کاربر اصلی "></i>
              </template>
              <template v-slot:cardbox-icon2><i v-if="person.IsActive != true && person.tblUserIdLogin == 0" class="fad fa-user mt-2"></i></template>
              <template v-slot:b-dropdown-item>
                <b-dropdown-item href="#" class="text-center" @click="OnclipBoard(person)" v-if="!person.IsActive == true">کپی تلفن</b-dropdown-item>
                <b-dropdown-item href="#" class="text-center" @click="SendSms(person)" v-if="!person.IsActive == true && person.PerMobile">پیامک</b-dropdown-item>
              </template>
              <template v-slot:cardbox-body>
                <h5 class="card-title text-center">{{ person.FullName }}</h5>
                <p class="card-text detail mt-4">سمت : {{ person.tblcomboGrp1SematName }}</p>
                <p v-if="person.PerTamas && person.PerTamas != ''" class="card-text detail">تلفن : {{ person.PerTamas }}</p>
                <p v-if="person.PerMobile && person.PerMobile != ''" class="card-text detail">موبایل : {{ person.PerMobile }}</p>
                <p v-if="person.PerTozihat && person.PerTozihat != ''" class="card-text detail">توضیحات : {{ person.PerTozihat }}</p>
                <p v-if="person.Email && person.Email != '' && person.Email != null" class="card-text detail">ایمیل : {{ person.Email }}</p>
              </template>
            </CardBox>
          </div>
          
        </div>
        <communications v-if="$store.state.renderComponentGrid && modal2 && IsComponent==false "  @Inserted="refresh" :CommunicationList="Customer.communications" :CustomerId="Customer.Customer.Id"></communications>
    </template>
    <template v-slot:footer> </template>
  </modal>
  </div>

</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '@/pages/Modal/Modal.vue';
import CardBox from '@/components/CardBox/CardBox'
import Communications from '../UserMenu/Components/Communications.vue'
export default {
  components: { datePicker: VuePersianDatetimePicker, Card, SearchableCombo, BnpGrid,Modal,CardBox,Communications },
  data() {
    return {
      selected: 'Null',
      options: [
        { text: 'دارد', value: '1' },
        { text: 'ندارد', value: '0' },
        { text: 'همه', value: 'Null' },
      ],
      Isrequired: false,
      loadingRender: false,
      Rows: [],
      Column: [],
      tarix: ['', ''],
      DataAxios: {},
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'TaskManager',
        Token: this.$session.get('Token'),
      },
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmTaskManager',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      IsComponent: false,
      Customer:null,
      modal1:false,
      modal2:false
    }
  },
  methods: {
    refresh(){
      let data ={TblCustomerId: this.Customer.Customer.Id }
      this.OnPhone(data)
      this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
    },
    OnPhone(data){
      this.$store.state.Modal=false
      this.$store.state.loading = true
      this.$GetCustomerDetail(data.TblCustomerId).then((res) => {
          this.$store.state.Modal=true
          this.modal1=false
          this.modal2=true
          this.Customer=res
          this.$store.state.loading = false
        }).finally(()=>{
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
        })
    },
    OnclipBoard(person) {
      navigator.clipboard.writeText(person.PerMobile && person.PerMobile.trim() != '' ? person.PerMobile : person.PerTamas)
      this.$toasted.success(' شماره تلفن ' + person.FullName + ' کپی شد', {})
    },
    OnPersonel(data){
      this.$store.state.Modal=false
      this.$store.state.loading = true
      this.$GetCustomerDetail(data.TblCustomerId).then((res) => {
          this.$store.state.Modal=true
          this.modal1=true
          this.modal2=false
          this.Customer=res
          this.$store.state.loading = false
        })
          
    },
     SendSms(personel) {
      if (personel.PerMobile.trim().length != 11) {
        this.$mySweetDefaultTost('خطا', 'شماره موبایل ثبت شده صحیح نیست', 'error', 1500)
      } else {
        this.$store.state.Customer.Customer = this.Customer.Customer

        this.$router.push({ name: 'CustomerSms', params: { personel: personel, PerMobile: personel.PerMobile, PerName: personel.FullName, PerId: personel.Id, CustomerId: personel.tblCustomerId, CustomerName: this.Customer.Customer.CustomerName } })
      }
    },
    ChangRadio(data) {

    },
    // OnDetail(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.TblCustomerId } })

    // },
    DoneTask(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row)

      row.Done = true
      row.IsView = true
      row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.DataAxiosUpdate.Action = 'Task'
      this.DataAxiosUpdate.ArryfildValue = row
      this.$PutData_Body(this.DataAxiosUpdate)
        .then((data) => {
          if (data.status == 'Ok') {
            this.$SetLog(row, 0, 1)
            this.$toasted.success('فعالیت با موفقیت انجام شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
          } else {
            this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(10000)
                },
              },
            })
          }
        })
        .finally(() => {
          this.$store.state.renderComponentTicket = false
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponentTicket = true
            this.$store.state.renderComponent = true
          })
        })
    },
    OnEditNew(row) {
      if (this.IsComponent) {
        this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row, PropsCustomer: this.DataAxios.TblCustomerId } })
      } else {
        this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row } })
      }
    },
    OnView(row) {
      if (row.IsView == true) {
        if (this.IsComponent) {
          this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row, PropsCustomer: this.DataAxios.TblCustomerId } })
        } else this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row } })
      } else {
        this.$store.state.OldDataForLog = JSON.stringify(row)
        row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
        row.IsView = true
        this.DataAxiosUpdate.Action = 'Task'
        this.DataAxiosUpdate.ArryfildValue = row
        this.$PutData_Body(this.DataAxiosUpdate)
          .then((data) => {
            if (data.status == 'Ok') {
              row.DateView = data.taskStatus.dateView
              if (this.IsComponent) {
                this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row, PropsCustomer: this.DataAxios.TblCustomerId } })
              } else this.$router.push({ name: 'DetailTask', params: { Status: 'Edit', DataRow: row } })
            } else {
              this.$toasted.error('مشکل در بروزرسانی فعالیت لطفا مجدد تلاش کنید', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(10000)
                  },
                },
              })
            }
          })
          .finally(() => {})
      }
    },
    GetResulUserId(data) {
      if (data.id != null) {
        this.DataAxios.TblUserIdTask = data.id
      }
    },
    GetResulTblCostomer(data) {
      if (data.id != null) {
        this.DataAxios.TblCustomerId = data.id
      }
    },
    Search(data) {
      this.loadingRender = true
      if (data) {
        var row = {}
        this.Rows = []

        row.tblUserIdTask = this.IsComponent ? null : this.DataAxios.TblUserIdTask
        row.TaskDateAz = this.tarix.length > 0 ? this.tarix[0] : null
        row.TaskDateTa = this.tarix.length > 1 ? this.tarix[1] : null
        row.tblCustomerId = this.IsComponent ? this.CustomerIdprop : this.DataAxios.TblCustomerId
        row.Done = this.DataAxios.Done
        row.IsReply = this.selected
        this.DataAxios_GetData.ArryfildValue = row
        this.$PostData(this.DataAxios_GetData)
          .then((data) => {
            if (data.length > 0 && data[0].Id != null) {
              // for (let index = 0; index < data.length; index++) {
              //   this.Rows.push(data[index])
              // }
              this.Rows = data
            } else {
              this.Rows = []
              this.loadingRender = false
            }
          })
          .finally(() => {
            this.loadingRender = false
            this.$store.state.renderComponentTicket = false
            this.$nextTick(() => {
              this.$store.state.renderComponentTicket = true
            })
          })
      } else {
        if (this.$ValidForm('taskmanagerrow')) {
          this.loadingRender = true
          var row = {}
          this.Rows = []
          row.tblUserIdTask = this.IsComponent ? null : this.DataAxios.TblUserIdTask
          row.TaskDateAz = this.tarix.length > 0 ? this.tarix[0] : null
          row.TaskDateTa = this.tarix.length > 1 ? this.tarix[1] : null
          row.tblCustomerId = this.IsComponent ? this.CustomerIdprop : this.DataAxios.TblCustomerId
          row.Done = this.DataAxios.Done
          row.IsReply = this.selected
          this.DataAxios_GetData.ArryfildValue = row
          this.$PostData(this.DataAxios_GetData)
            .then((data) => {
              if (data.length > 0 && data[0].Id != null) {
                for (let index = 0; index < data.length; index++) {
                  this.Rows.push(data[index])
                }
              } else {
                this.loadingRender = false
                this.Rows = []
              }
            })
            .finally(() => {
              this.loadingRender = false
              this.$store.state.renderComponentTicket = false
              this.$nextTick(() => {
                this.$store.state.renderComponentTicket = true
              })
            })
        } else {
          this.loadingRender = false
        }
      }
    },
  },
  beforeMount() {
    this.$GetColumns(this.DataAxoisCol, true)
      .then((data) => {
        this.Column = data
      })
      .finally(() => {
        this.$store.state.renderComponentTicket = false
        this.$nextTick(() => {
          this.$store.state.renderComponentTicket = true
        })
      })
  },
  created() {
    if (this.CustomerIdprop) {
      this.IsComponent = true
      this.modal1=false
      this.modal2=false
    }else{
      this.tarix[1]=this.$store.state.JalaliDate
    }
    this.DataAxios.TblUserIdTask = this.$session.get('UserInfo').tblUserId
  },
  mounted() {
    this.Search(this.DataAxios.TblUserIdTask)
  },
  props: ['CustomerIdprop'],
}
</script>
<style scoped></style>
